<div class="task-watcher-modal">
  <!-- Search users -->
  <div class="tw-search-wrap">
    <lucide-icon name="search" [size]="14" class="tw-search-icon" [strokeWidth]="2"></lucide-icon>
    <input
      type="text"
      class="tw-search-input"
      [(ngModel)]="searchText"
      (ngModelChange)="onSearchTextChange()"
      placeholder="Search team members..."
    />
  </div>

  <!-- User list -->
  <div class="tw-user-list">
    <div *ngIf="filteredListOfUsers.length === 0" class="tw-empty">
      No users found.
    </div>

    <div
      class="tw-user-item"
      *ngFor="let user of filteredListOfUsers"
      [ngClass]="{ 'tw-user-item--selected': user.isWatchingThisTask, 'tw-user-item--disabled': user.id === assignedUserId }"
      [title]="user.id === assignedUserId ? 'This person is the assignee. Reassign the task first to change their role.' : null"
      (click)="user.id === assignedUserId ? null : (user.isWatchingThisTask ? removeWatcher(user.id) : addWatcher(user)); $event.stopPropagation()"
    >
      <div class="tw-avatar">
        <img
          *ngIf="user.profilePictureUrl"
          [src]="user.profilePictureUrl"
          class="tw-avatar-img"
        />
        <span *ngIf="!user.profilePictureUrl" class="tw-avatar-initials">
          {{ user.userInitials }}
        </span>
      </div>
      <span class="tw-user-name">
        {{ user.name }}
      </span>
      <lucide-icon *ngIf="user.isWatchingThisTask" name="check" [size]="14" class="tw-check" [strokeWidth]="2"></lucide-icon>
    </div>
  </div>

  <!-- Current watchers -->
  <div class="tw-footer" *ngIf="watchers?.length">
    <div class="tw-footer-label">Watching ({{ watchers.length }})</div>
    <div class="tw-chips">
      <span
        class="tw-chip"
        *ngFor="let watcher of watchers"
      >
        <span class="tw-chip-name">{{ watcher.userId === appSession.userId ? 'You' : (watcher.userName || watcher.name) }}</span>
        <button type="button" class="tw-chip-remove" (click)="removeWatcher(watcher.userId); $event.stopPropagation()">
          <lucide-icon name="x" [size]="12" [strokeWidth]="2"></lucide-icon>
        </button>
      </span>
    </div>
  </div>
</div>

<!-- Contributor → Watcher confirmation modal -->
<div class="vf-confirm-overlay" *ngIf="showDemoteConfirm" (click)="cancelDemoteToWatcher()">
  <div class="vf-confirm-modal" (click)="$event.stopPropagation()">
    <h1 class="vf-confirm-title">Make {{ pendingDemoteUser?.name }} a watcher?</h1>
    <p class="vf-confirm-text">This person is a contributor and has steps on this task. Their steps will become unassigned.</p>
    <div class="vf-confirm-footer">
      <button type="button" class="vf-confirm-btn vf-confirm-btn--cancel" (click)="cancelDemoteToWatcher()">Cancel</button>
      <button type="button" class="vf-confirm-btn vf-confirm-btn--primary" (click)="confirmDemoteToWatcher()">Make watcher</button>
    </div>
  </div>
</div>

<style>
.task-watcher-modal {
  padding: 8px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.vf-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}
.vf-confirm-modal {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  width: 100%;
  max-width: 460px;
  padding: 20px 24px 16px;
}
.vf-confirm-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 8px;
}
.vf-confirm-text {
  font-size: 13px;
  color: #6b7280;
  margin: 0 0 16px;
  line-height: 1.5;
}
.vf-confirm-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}
.vf-confirm-btn {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  border: 0;
  transition: background 0.15s ease, color 0.15s ease;
}
.vf-confirm-btn--cancel {
  background: transparent;
  color: #374151;
}
.vf-confirm-btn--cancel:hover { background: #f3f4f6; }
.vf-confirm-btn--primary {
  background: #111827;
  color: #ffffff;
}
.vf-confirm-btn--primary:hover { background: #000000; }


/* Search */
.tw-search-wrap {
  position: relative;
  margin-bottom: 8px;
}
.tw-search-icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
}
.tw-search-input {
  width: 100%;
  height: 32px;
  padding: 6px 10px 6px 30px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #ffffff;
  font-size: 13px;
  color: #111827;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
}
.tw-search-input:focus {
  border-color: #2563eb;
}
.tw-search-input::placeholder {
  color: #9ca3af;
}

/* List */
.tw-user-list {
  max-height: 220px;
  overflow-y: auto;
  margin: 0 -4px;
}
.tw-empty {
  padding: 12px;
  color: #6b7280;
  font-size: 13px;
  text-align: center;
}
.tw-user-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s;
}
.tw-user-item:hover {
  background: #f3f4f6;
}
.tw-user-item--selected {
  background: #f3f4f6;
}
.tw-user-item--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.tw-user-item--disabled:hover { background: transparent; }

/* Checkbox */
.tw-checkbox {
  width: 16px;
  height: 16px;
  border: 1.5px solid #d1d5db;
  border-radius: 3px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s;
}
.tw-checkbox--checked {
  background: #2563eb;
  border-color: #2563eb;
}
.tw-checkbox-check {
  color: #ffffff;
}

/* Avatar */
.tw-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #4b5563;
  font-size: 11px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}
.tw-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.tw-avatar-initials {
  text-transform: uppercase;
  line-height: 1;
}

/* Selected check */
.tw-check { color: #2563eb; flex-shrink: 0; }

/* Name */
.tw-user-name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #111827;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Footer (Watching list) */
.tw-footer {
  padding: 12px;
  border-top: 1px solid #e5e7eb;
  margin-top: 0px;
}
.tw-footer-label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 10px;
  line-height: normal;
}
.tw-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.tw-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: #f3f4f6;
  border: 0;
  border-radius: 4px;
  font-size: 12px;
  color: #374151;
  line-height: normal;
}
.tw-chip-name {
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tw-chip-remove {
  padding: 1px;
  border: 0;
  background: transparent;
  color: #374151;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  line-height: 0;
  border-radius: 3px;
  transition: background 0.15s;
}
.tw-chip-remove:hover {
  background: #e5e7eb;
}
</style>
